import styled from 'styled-components'

import { ResponsiveImage, TypeStyle } from '@syconium/little-miss-figgy'

import { PlacementCardShell } from '../../PlacementPicker/styles'

/** About as wide as a tile renders, for sizing the logo image it loads. */
export const LOGO_TILE_WIDTH = 172

export const LogoGrid = styled.div`
  display: grid;
  gap: ${o => o.theme.spacing(3)};
  grid-template-columns: repeat(2, minmax(0, 1fr));
`

/** A placement card's selected and disabled looks, shaped as a square tile. */
export const LogoTile = styled(PlacementCardShell)`
  aspect-ratio: 1;
  overflow: hidden;
  position: relative;
`

export const LogoTileButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  height: 100%;
  padding: ${o => o.theme.spacing(2)};
  width: 100%;

  &[aria-disabled='true'] {
    cursor: not-allowed;
  }

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: -2px;
  }
`

export const LogoImage = styled(ResponsiveImage)<{ $disabled: boolean }>`
  height: 100%;
  object-fit: contain;
  opacity: ${o => (o.$disabled ? 0.5 : 1)};
  width: 100%;
`

export const EditLogoButton = styled.button`
  align-items: center;
  background-color: ${o => o.theme.color.fill.background};
  border-radius: 50%;
  display: flex;
  height: ${o => o.theme.spacing(8)};
  justify-content: center;
  position: absolute;
  right: ${o => o.theme.spacing(2)};
  top: ${o => o.theme.spacing(2)};
  width: ${o => o.theme.spacing(8)};

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: 2px;
  }
`

/** Names what the customer is buying with the logo — the digitizing, not just the embroidery. */
export const DigitizationBadge = styled.span`
  ${TypeStyle.css.bodyNano}
  background-color: ${o => o.theme.color.fill.subtle};
  bottom: 0;
  display: block;
  left: 0;
  padding: ${o => o.theme.spacing(2)};
  pointer-events: none;
  position: absolute;
  right: 0;
  font-weight: ${o => o.theme.typography.font.weight[700]};
  text-align: center;
  text-transform: uppercase;
`

export const AddNewLogoButton = styled.button`
  align-items: center;
  aspect-ratio: 1;
  background-color: ${o => o.theme.color.fill.background};
  border: 2px dashed ${o => o.theme.color.stroke.neutral.border.decoration.on.strong};
  border-radius: ${o => o.theme.spacing(2)};
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: ${o => o.theme.spacing(2)};
  justify-content: center;

  &:focus-visible {
    outline: 2px solid ${o => o.theme.color.effect.focus.outline.on.background};
    outline-offset: 2px;
  }
`

export const AddNewLogoLabel = styled.span`
  ${TypeStyle.css.headlineExtraSmall}
`

export const AddNewLogoPrice = styled.span`
  ${TypeStyle.css.bodyMicro}
  color: ${o => o.theme.color.text.secondary.on.background};
  font-weight: ${o => o.theme.typography.font.weight[700]};
`
